<template>
  <a
    v-tooltip="{
      content: tooltip && tooltip.length > 0 ? tooltip : 'EMPTY',
      classes: 'badge-theme text-pre',
    }"
    :class="badgeClass"
  >
    {{ text }}
    <font-awesome-icon :icon="icon" />
  </a>
</template>

<script type="text/babel">
export default {
  props: {
    tooltip: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "Notes",
    },

    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  data() {
    return {
      color: "badge-secondary",
      icon: ["fal", "mouse-pointer"],
    };
  },

  computed: {
    badgeClass() {
      return `badge ${this.color} ${this.size}`;
    },
  },
};
</script>
